<template>
  <div>
    <div id="mycard" class="card">

      <WindowTitleBar title="Stentering QC Creation" @loadData="loadData" @close_window="closeThis" >{{setTitle()}}</WindowTitleBar>

      <div class="card-body">

      <div class="row">

        <div class="col-md-2">
          <div class="form-group form-group-material ">
            <label class="control-label text-semibold">Shift</label>
            <select class="form-control" autofocus="" v-if="qc"  v-model="qc.shift_id">
              <option value="2" selected>Day</option>
              <option value="3">Night</option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Machine</label>
            <select class="form-control" required="" v-if="qc"  v-model="qc.mac_id">
              <option v-for="machine in machines" v-bind:value="machine.id">
                {{ machine.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <!--          <div class="form-group form-group-material">-->
          <!--            <label class="control-label text-semibold">Machine</label>-->
          <!--            <select class="form-control" autofocus="" required="" v-if="voucher"  v-model="voucher.machine.id" >-->
          <!--              <option v-for="machine in machines" v-bind:value="machine.id">-->
          <!--                {{ machine.name }}-->
          <!--              </option>-->
          <!--            </select>-->
          <!--          </div>-->
        </div>

        <div class="col-md-4">
        </div>


        <div class="col-md-2">
          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Date</label>
            <input type="date" class="form-control text-right" v-if="qc" v-model="qc.doc_date">
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">

          <!-- Basic layout-->
          <div class="card">


            <div class="card-body">

              <!--  Detail Table -->
              <div class="row">
                <div class="table-responsive">

                  <table id="mytable" class="table table-no-bordered">
                    <thead style="background-color: lightgrey">
                      <tr>
                        <th style="width: 100px;" >S.No</th>
                        <th>FabCode</th>
                        <th>#</th>
                        <th>Quality</th>
                        <th>Color</th>
                        <th style="text-align: right;">Weight</th>
                        <th style="text-align: right;">Damage</th>
                        <th style="width: 30px;">Action</th>
                      </tr>
                    </thead>
                    <tbody v-for="(fab,index) in qc.list" >
                      <Detail :myindex="index" :myrow="fab" v-on:on_value_change="on_value_change" v-on:onRemoveRow="removeRow" ></Detail>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>
                          <button id="btnAddRow" type="button" class="btn border-success text-success-800 btn-flat btn-icon btn-rounded legitRipple" @click="addRow">
                            <i class="icon-plus3"></i>
                          </button>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <!-- / Detail Table -->


            </div>
          </div>
          <!-- /basic layout -->

        </div>

      </div>

      <div class="row">

        <div class="col-md-3">
          <div class="form-group form-group-material ">
            <label class="control-label text-semibold">Waste</label>
            <input class="form-control"  type="number" v-model="qc.fab_waste"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group form-group-material ">
            <label class="control-label text-semibold">Operator 1</label>
            <select class="form-control" v-if="qc" v-model="qc.emp1_id">
              <option v-for="emp in emps" v-bind:value="emp.id">
                {{ emp.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group form-group-material ">
            <label class="control-label text-semibold">Operator 2</label>
            <select class="form-control" v-if="qc" v-model="qc.emp2_id">
              <option v-for="emp in emps" v-bind:value="emp.id">
                {{ emp.name }}
              </option>
            </select>
          </div>
        </div>


        <div class="col-md-3">

        </div>

      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Narration</label>
            <textarea id="txtremarks" class="form-control" placeholder="Narration"  v-if="qc" v-model="qc.remarks" > </textarea>
          </div>
        </div>


        <div class="col-md-6">

        </div>

        <div class="col-md-3 text-right">

          <button id="btnSave" type="button" class="btn bg-green-800 btn-raised active" @click="perform_save_action" >Save</button>
          <button type="button" id="btnclose" class="btn btn-default" data-dismiss="" >Clear</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'
  import { store } from '@/store/store.js'
  import Detail from './StenteringQcDetailRow'
  import WindowTitleBar from '../../../components/core/WindowTitleBar'

  export default {
    name: 'StenteringQcForm',
    components: {
      Detail,
      WindowTitleBar,
    },
    store,
    props: {
      myqc: {
        type: Object,
          default: () => JSON.parse('{"id":0,"finyear":2000,"status":"Active","cmp_id":1,"mac_id":1,"machine":{"id":0,"type":0,"nature":0,"name":""},"shift":{"id":0,"type":0,"name":""},"doc_date":"0001-01-01","emp1":{"id":0,"status":0,"emp_code":"","name":""},"emp2":{"id":0,"status":0,"emp_code":"","name":""},"list":[],"fab_waste":0,"weight":0,"damages":0,"remarks":""}')
      }
    },
    beforeMount () {
      this.qc = this.myqc;
    },
    data() {
      return {
        defects:[],
        machines: [],
        emps:[],
        qc : JSON.parse('{"id":0,"finyear":2000,"status":"Active","cmp_id":1,"mac_id":1,"machine":{"id":0,"type":0,"nature":0,"name":""},"shift":{"id":0,"type":0,"name":""},"doc_date":"0001-01-01","emp1":{"id":0,"status":0,"emp_code":"","name":""},"emp2":{"id":0,"status":0,"emp_code":"","name":""},"list":[],"fab_waste":0,"weight":0,"damages":0,"remarks":""}'),
        mycard: {}
      }
    },
    created(){

    },
    mounted(){
      const self = this;
      self.mycard = $('#mycard');

      if (self.qc.doc_date == '0001-01-01' || self.qc.doc_date == '2000-01-01') {
        self.qc.doc_date = moment().format('YYYY-MM-DD');
      }
      self.loadData();

      setTimeout( ()=> {
        $('#cmbshift').focus();
      }, 500);

    },
    filters:{
      weightFormat (val){
        try {
          return val.toFixed(3);
        }catch (e) {

        }
        return val;
      }
    },
    methods:{
      setTitle() {
        return this.qc.id == 0 ? "Stentering QC Creation" : "Doc No: " + this.qc.doc_no + "  Stentering QC Creation Updation";
      },
      closeThis(){
        this.$emit('stentering_qc_window_closed');
        if(this.myqc.id > 1){
          // this.$modal.hide('stentering_qc_window');
          this.qc = JSON.parse('{"id":0,"finyear":2000,"status":"Active","cmp_id":1,"mac_id":1,"machine":{"id":0,"type":0,"nature":0,"name":""},"shift":{"id":0,"type":0,"name":""},"doc_date":"0001-01-01","emp1":{"id":0,"status":0,"emp_code":"","name":""},"emp2":{"id":0,"status":0,"emp_code":"","name":""},"list":[],"fab_waste":0,"weight":0,"damages":0,"remarks":""}');
        }else{
          this.$router.push("/")
        }
      },
      loadData(){
        this.loadEmps();
      },
      addRow(){
        const self = this;
        let receipt = {"idx":0,"id":0,"master_id":0,"fabric_id":0,"item_id":0,"stentering_damages":0,"fab_weight":0,"weight":0,"fabric":{"id":0,"cmp_id":0,"shift_id":0,"mac_id":0,"emp_id":0,"item_id":0,"qua_id":0,"col_id":0,"fab_weight":0,"fab_waste_weight":0,"yarn_waste_weight":0,"defects_count":0,"needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_id":0,"stentering_damages":0,"stentering_qc_id":0,"stentering_qc_damages":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""}}};
        self.$data.qc.list.push(receipt);
        setTimeout(function(){
          $("tbody>tr").last().find("td:eq(1) input").focus();
        }, 99);

      },
      on_value_change(rowIndex, colIndex, val) {
        const self = this;
        self.qc.list[rowIndex].stentering_qc_damages = val;
      },
      removeRow(index){
        const self = this;

        if (index > -1) {
          self.qc.list.splice(index, 1);
        }
      },
      loadEmps(){

        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.machines = [];
        fetch(`${process.env.VUE_APP_ROOT_API}api/machines/type/4`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok){

            if( Array.isArray(resp.data)){
              self.machines = resp.data;
            }

          }else{
            swal (  {title:"Oops" ,  text: resp.msg,  type: "error"});
          }
        }).catch(function (err) {
          swal (  {title:"Oops" ,  text: err.toString(),  type: "error"});
        });

        self.emps = [];
        fetch(`${process.env.VUE_APP_ROOT_API}api/employees`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.ok){
            if(  !_.isNull(resp.data)){
              self.emps = resp.data;
            }
          }else{
            swal (  {title:"Oops" ,  text: resp.msg,  type: "error"});
          }
        }).catch(function (err) {
          swal (  {title:"Oops" ,  text: err.toString(),  type: "error"});
        });
      },
      loadFabric(code, idx){
        if(code < 1) {
          return;
        }

        const self = this;
        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        $(self.mycard).block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        self.qc.list[idx] = {"idx":0,"id":"","status":0,"type":0,"qc_code":0,"is_cr":"","finyear":0,"doc_no":0,"machine":{"id":0,"type":0,"nature":0,"name":"","p_name":""},"shift":{"id":0,"type":0,"name":""},"operator":{"id":0,"status":0,"emp_code":"","name":""},"date":"0001-01-01","color":{"id":0,"status":0,"name":""},"quality":{"id":0,"name":""},"fabric":{"id":0,"nature":0,"active":"","name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0}},"fab_wgt":0,"yarn_waste":{"id":0,"nature":0,"active":"","ledger_group":{"id":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false},"name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"yarn_waste_wgt":0,"fab_waste":{"id":0,"nature":0,"active":"","ledger_group":{"id":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false},"name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"fab_waste_wgt":0,"defects_count":0,"remarks":"","needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_qc_damages":0};

        fetch(`${process.env.VUE_APP_ROOT_API}api/knitting/receipt/${code}`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            if(!_.isNull(resp.data)){
              self.qc.list[idx] = resp.data;
            }
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        }).finally(function () {
          $(self.mycard).unblock();
        });

      },
      hasDuplicates(arr) {
        const set = new Set(arr);
        return set.size !== arr.length;
      },
      parseErrors(errorInput) {
        let errors = {};

        // If input is a string, try parsing it
        if (typeof errorInput === 'string') {
          try {
            errors = JSON.parse(errorInput);
          } catch (e) {
            // It's a plain string, return as-is
            return errorInput;
          }
        } else if (typeof errorInput === 'object' && errorInput !== null) {
          errors = errorInput;
        } else {
          return 'Unknown error format';
        }

        // Now format like before
        return Object.entries(errors)
          .map(([field, messages]) => {
            const label = field.replace(/\.\d+\./g, ' → ').replace(/\./g, ' ');
            // return `${messages.join(', ')}`;
            return `<b>${label}</b>: ${messages.join(', ')}`;
          })
          .join('<br>');
      },
      perform_save_action(){
          const self = this;

          self.$data.qc.status = "Active";
          self.$data.qc.cmp_id = self.$store.state.user.company.id;
          self.qc.finyear = store.state.user.finyear;

          self.qc.emp1_id = parseInt(self.qc.emp1_id);
          self.qc.emp2_id = parseInt(self.qc.emp2_id);
          self.qc.shift_id = parseInt(self.qc.shift_id);
          self.qc.mac_id = parseInt(self.qc.mac_id);
          self.qc.fab_waste = parseFloat(self.qc.fab_waste);

          let myvoucher =  JSON.parse(JSON.stringify(self.qc));

          myvoucher.doc_date = moment(self.qc.doc_date).format('YYYY-MM-DD');
          myvoucher.finyear = store.state.user.finyear;
          myvoucher.status = "Active";
          myvoucher.cmp_id = self.$store.state.user.company.id;
          myvoucher.list = [];

          self.qc.list.forEach(function (row) {

            row.fabric_id = parseInt(row.fabric_id);
            row.item_id = parseInt(row.fabric.item_id);
            if(row.stentering_qc_damages == null) {
              row.stentering_qc_damages = 0;
            }
            row.fab_weight = parseFloat(row.fabric.fab_weight);
            row.stentering_qc_damages = parseInt(row.stentering_qc_damages);

            myvoucher.list.push(row);

            myvoucher.damages += row.stentering_qc_damages;
            myvoucher.weight +=  row.fab_weight;
          });

          if(myvoucher.emp1_id < 1) {
            alert("Invalid Operator 1");
            return
          }else if(myvoucher.emp2_id < 1) {
            alert("Invalid Operator 2");
            return
          }else if(myvoucher.shift_id < 1){
            alert("Invalid Shift");
            return
          }else if(myvoucher.list.length < 1){
            alert("Invalid Fabrics");
            return
          }else if(myvoucher.fab_waste < 0){
            alert("Invalid Waste Quantity");
            return
          }else if(myvoucher.mac_id < 1){
            alert("Invalid machine");
            return
          }

          const requestOptions = {
            method:  (myvoucher.id == 0 ? 'POST' : 'PUT'),
            mode:"cors",
            headers: userService.authHeader(),
            body: JSON.stringify(myvoucher)
          };

          console.log(JSON.stringify(myvoucher));

          $('#mycard').block({
            message: '<i class="icon-spinner2 spinner"></i>',
            overlayCSS: {
              backgroundColor: '#fff',
              opacity: 0.8,
              cursor: 'wait',
              'box-shadow': '0 0 0 1px #ddd'
            },
            css: {
              border: 0,
              padding: 0,
              backgroundColor: 'none'
            }
          });

          //alert(`${process.env.VUE_APP_ROOT_API}api/stentering_qc`);
          fetch(`${process.env.VUE_APP_ROOT_API}api/stentering_qc`,requestOptions).then(userService.handleResponse).then(function (resp) {
            if(resp.ok) {
              self.qc.id = 0;
              self.qc.list = [];
              swal ( { title: "Success!" ,  text: resp.msg, type:  "success", onClose: () => {
                  $('#cmbshift').focus();
                }});

              self.$emit('stenteringqc_saved', resp.data);

            } else {
              swal ( { title: "Oops!" ,  html: self.parseErrors(resp.msg), type:  "error"} );
            }
          }).catch(function (err) {
            swal ( { title: "Oh noes!" ,  text: err.toString() , type:  "error"} );
          }).finally(function () {
            $('#mycard').unblock();
          });

        },
      }
  }
</script>

<style scoped>
  input:focus {
    background: #feff00;
  }

  textarea:focus {
    background: #feff00;
  }

  select:focus {
    background: #feff00;
  }

  button:focus {
    background: #feff00;
    color: #0a0a0a!important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
